(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CFG = window.lwWheelConfig || { prizes: [], delay: 1.5 };
    var PRIZES = CFG.prizes;
    var N = PRIZES.length, SEG = 360 / N;
    var wheel = document.getElementById("lwWheel");
    var spinBtn = document.getElementById("lwSpin");
    var mask = document.getElementById("lwMask");
    var result = document.getElementById("lwResult");
    var prizeEl = document.getElementById("lwPrize");
    var codeEl = document.getElementById("lwCode");
    var tipEl = document.getElementById("lwTip");
    var goBtn = document.getElementById("lwGo");
    var closeBtn = document.getElementById("lwClose");

    var current = 0, spinning = false;

    function applyDiscount(code) {
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { if (!r.ok) throw new Error("fail"); return r.json(); });
    }

    function spin() {
      if (spinning) return;
      spinning = true; spinBtn.disabled = true;
      result.classList.remove("show");
      goBtn.style.display = "none";

      var idx = Math.floor(Math.random() * N);
      var desiredMod = (360 - (idx * SEG + SEG / 2)) % 360;
      var currentMod = ((current % 360) + 360) % 360;
      var delta = desiredMod - currentMod;
      if (delta <= 0) delta += 360;
      current += 360 * 5 + delta;
      wheel.style.transform = "rotate(" + current + "deg)";

      var done = false;
      function show() {
        if (done) return; done = true;
        var p = PRIZES[idx];
        prizeEl.textContent = "🎁 你抽中：" + p.name;
        applyDiscount(p.code).then(function () {
          codeEl.style.display = "none";
          tipEl.innerHTML = "✅ 已自动为你锁定，<b>去结算即生效，无需输入</b>";
          goBtn.style.display = "inline-block";
        }).catch(function () {
          codeEl.textContent = p.code;
          codeEl.style.display = "inline-block";
          tipEl.textContent = "结账时输入以上优惠码即可";
          goBtn.style.display = "inline-block";
        });
        result.classList.add("show");
        spinning = false; spinBtn.disabled = false;
      }
      wheel.addEventListener("transitionend", show, { once: true });
      setTimeout(show, 5000);
    }

    goBtn.addEventListener("click", function () { window.location.href = "/cart"; });
    spinBtn.addEventListener("click", spin);
    closeBtn.addEventListener("click", function () { mask.hidden = true; });
    mask.addEventListener("click", function (e) { if (e.target === mask) mask.hidden = true; });

    var DELAY = CFG.delay * 1000;
    var KEY = "lwShownDate", today = new Date().toDateString();
    if (localStorage.getItem(KEY) !== today) {
      setTimeout(function () {
        mask.hidden = false;
        try { localStorage.setItem(KEY, today); } catch (e) {}
      }, DELAY);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
